import type { Fields } from "@vuex-orm/core";
// eslint-disable-next-line import/no-cycle
import { Action } from "./ActionHierarchy";

export class Slide extends Action {
  // This is the name used as module name of the Vuex Store.
  public static entity = "slides";

  public static baseEntity = "actions";

  public readonly isBrowserAction = false;

  public static fields(): Fields {
    return {
      ...super.fields(),
    };
  }

  public static get humanName(): string {
    return "Slide";
  }
}
